import React from 'react';
import { MapPin, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { jobListings } from '../data/mockData';
import Header from './Header';
import Footer from './Footer';

const VacanciesPage = ({ onConsultationClick, onVacancyClick }) => {
  return (
    <>
      <Header onConsultationClick={onConsultationClick} />
      
      <section className="pt-32 pb-20 bg-gray-50 min-h-screen">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          {/* Back link */}
          <Link 
            to="/" 
            className="inline-flex items-center text-gray-600 hover:text-[#FFD000] mb-8 transition-colors duration-200"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Link>

          <div className="text-center mb-16">
            <h1 className="text-3xl sm:text-4xl font-normal text-black mb-6" style={{ fontFamily: "'DM Serif Display', serif", textShadow: 'none', WebkitFontSmoothing: 'antialiased' }}>
              Current Opportunities
            </h1>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
              Structured roles with hospitality operators seeking stability-focused leaders.
            </p>
            <p className="text-base text-gray-600 max-w-3xl mx-auto italic">
              We accept a limited number of mandates at any given time. Only select leadership roles are publicly listed.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {jobListings.map((job) => (
              <div 
                key={job.id}
                className="bg-white border border-gray-200 rounded-lg p-8 hover:border-[#FFD000] transition-all duration-300 group"
              >
                <div className="flex items-start justify-between mb-4">
                  <h3 className="text-2xl font-bold text-black group-hover:text-[#FFD000] transition-colors duration-300">
                    {job.title}
                  </h3>
                  <span className="bg-[#FFD000]/10 text-[#FFD000] px-3 py-1 rounded-full text-sm font-semibold whitespace-nowrap ml-4">
                    {job.type}
                  </span>
                </div>

                <div className="flex items-center mb-4 text-gray-600">
                  <MapPin className="h-4 w-4 mr-2" />
                  <span className="text-sm">{job.location}</span>
                </div>

                <p className="text-gray-700 mb-6 leading-relaxed">
                  {job.description}
                </p>

                <div className="mb-6">
                  <h4 className="text-black font-semibold mb-3">Key Requirements:</h4>
                  <ul className="space-y-2">
                    {job.requirements.map((req, idx) => (
                      <li key={idx} className="flex items-start text-gray-600 text-sm">
                        <span className="text-[#FFD000] mr-2">•</span>
                        {req}
                      </li>
                    ))}
                  </ul>
                </div>

                <Button 
                  onClick={onVacancyClick}
                  className="w-full bg-[#FFD000] hover:bg-[#FFD000]/90 text-black font-semibold"
                >
                  Apply for This Role
                </Button>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-gray-600 mb-4">
              Don't see a suitable role? We work on confidential mandates not always listed publicly.
            </p>
            <Button 
              onClick={onVacancyClick}
              variant="outline"
              className="border-2 border-[#FFD000] text-[#FFD000] hover:bg-[#FFD000] hover:text-black"
            >
              Submit Your Profile
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default VacanciesPage;
